module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overviewIcons",
    class: {
      shadow: (_vm.withShadow !== false)
    }
  }, [(_vm.activity.allows_instant_booking) ? _c('span', [_c('i', {
    staticClass: "fa fa-bolt"
  })]) : _vm._e(), _vm._v(" "), (_vm.activity.is_nature_tourism) ? _c('span', [_c('i', {
    staticClass: "fa fa-tree"
  })]) : _vm._e(), _vm._v(" "), (_vm.activity.is_low_mobility_accessible) ? _c('span', [_c('i', {
    staticClass: "fa fa-wheelchair"
  })]) : _vm._e(), _vm._v(" "), (_vm.activity.is_priced_per_occurrence) ? _c('span', [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.activity.group_min) + "–" + _vm._s(_vm.activity.group_max))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-145743cb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145743cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/OverviewIcons.vue
// module id = 760
// module chunks = 3